<template>
  <div class="container">
    <div class="page-title">请选择操作</div>

    <div class="content">
      <van-cell-group :border="false">
        <van-cell is-link @click="goTo('/payment')">
          <template #title>
            <div class="cell-content">
              <div class="icon-wrapper">
                <img class="icon-img" :src="contractIcon" alt="contract" />
              </div>
              <div class="text-content">
                <div class="option-title">合同入口</div>
                <div class="option-subtitle">管理和查看您的合同</div>
              </div>
            </div>
          </template>
        </van-cell>
        <van-cell is-link @click="goTo('/pay')">
          <template #title>
            <div class="cell-content">
              <div class="icon-wrapper">
                <img class="icon-img" :src="paymentIcon" alt="payment" />
              </div>
              <div class="text-content">
                <div class="option-title">付款入口</div>
                <div class="option-subtitle">发起一笔新的付款</div>
              </div>
            </div>
          </template>
        </van-cell>
        <van-cell is-link @click="goTo('/collection')">
          <template #title>
            <div class="cell-content">
              <div class="icon-wrapper">
                <img class="icon-img" :src="collectionIcon" alt="collection" />
              </div>
              <div class="text-content">
                <div class="option-title">收款入口</div>
                <div class="option-subtitle">提交收款确认申请和查看收款状态</div>
              </div>
            </div>
          </template>
        </van-cell>

        <van-cell is-link @click="goTo('/tax')">
          <template #title>
            <div class="cell-content">
              <div class="icon-wrapper">
                <img class="icon-img" :src="invoiceIcon" alt="invoice" />
              </div>
              <div class="text-content">
                <div class="option-title">发票入口</div>
                <div class="option-subtitle">提交发票申请和查看开票状态</div>
              </div>
            </div>
          </template>
        </van-cell>


      </van-cell-group>
    </div>
  </div>
</template>

<script>
import contractIcon from '@/assets/contract.png'
import paymentIcon from '@/assets/payment.png'
import collectionIcon from '@/assets/collection.png'
import invoiceIcon from '@/assets/invoice.png'
import common from '@/assets/js/common'
export default {
  name: "Entry",
  data() {
    return {
      contractIcon,
      paymentIcon,
      collectionIcon,
      invoiceIcon
    }
  },
  created() {
    
  },
  mounted() {
    if (!common.getAuth()) {
      this.$router.push({ path: "/auth" });
      return;
    }

    console.log("输出window.location.hostname",window.location.hostname);

    //TODO 如果是特殊的域名，则跳转到相应的页面
    if (window.location.hostname === 'appcon.yishouyou.com.cn') {
      this.$router.push({ path: "/payment" });
    }
  },
  methods: {
    goTo(path) {
      this.$router.push(path);
    }
  }
};
</script>

<style scoped>
.container {
  background-color: #ffffff; /* 全白底 */
  height: 100vh;
}

.page-title {
  text-align: center;
  font-size: 22px;
  line-height: 60px;
  font-weight: 400; /* 不加粗 */
  color: #111111;
  padding: 22px 0 18px; /* 调整与上下距离 */
  border-bottom: 1px solid #f0f0f0;
}

.content {
  padding-top: 6px;
  border-bottom: 1px solid #f0f0f0;
}

.van-cell-group {
  background-color: transparent;
  position: relative;
}

.van-cell {
  padding: 18px 16px;
}

/* 组上下边线：全宽、浅灰发丝线 */
:deep(.van-cell-group::before),
:deep(.van-cell-group::after) {
  border-color: #eeeeee;
}

/* 单项分隔线：从文本起始处缩进（避开左侧图标） */
:deep(.van-cell::after) {
  left: 56px; /* 图标28 + 间距12 + 余量16 对齐到文字 */
  right: 0;
  border-color: #f0f0f0;
}

/* 图标与文字首行顶端对齐 */
.cell-content {
  display: flex;
  align-items: flex-start;
}

.icon-wrapper {
  width: 28px;
  height: 28px;
  border-radius: 4px;
  margin-right: 12px;
  margin-top: 2px; /* 视觉上与标题对齐 */
  flex-shrink: 0;
}

.icon-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.text-content {
  text-align: left;
}

.option-title {
  font-size: 18px;
  color: #111111;
  font-weight: 400; /* 不加粗 */
}

.option-subtitle {
  font-size: 14px;
  color: #8a8a8a;
  margin-top: 6px;
}

/* 右侧箭头轻度弱化并垂直居中 */
:deep(.van-cell__right-icon) {
  color: #c8c9cc;
  font-size: 16px;
  display: flex;          /* 让容器成为弹性盒 */
  align-items: center;     /* 垂直居中内部图标 */
  align-self: stretch;     /* 使容器高度撑满整行，确保真正居中 */
  line-height: 1;          /* 消除行高影响 */
}
:deep(.van-cell__right-icon .van-icon) {
  line-height: 1;          /* 图标本身不受行高影响 */
  display: inline-block;
}
</style>
